<div class="top-our-stores-banner">
    <div class="overlay-text">Inicio / Nuestras tiendas</div>
</div>
